import { cx } from '../lib/cx';

export interface SpinnerProps {
  className?: string;
  /** Accessible label; omit inside a button that already announces its state. */
  label?: string;
}

/** The 14px accent spinner used by loading buttons and the SSO redirect. */
export function Spinner({ className, label }: SpinnerProps): React.JSX.Element {
  return (
    <span
      className={cx('ds-spinner', className)}
      {...(label === undefined
        ? { 'aria-hidden': true }
        : { role: 'status', 'aria-label': label })}
    />
  );
}
